import { render, staticRenderFns } from "./ModalTutoDelete.vue?vue&type=template&id=31641c50&scoped=true&"
import script from "./ModalTutoDelete.vue?vue&type=script&lang=js&"
export * from "./ModalTutoDelete.vue?vue&type=script&lang=js&"
import style0 from "./ModalTutoDelete.vue?vue&type=style&index=0&id=31641c50&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31641c50",
  null
  
)

component.options.__file = "ModalTutoDelete.vue"
export default component.exports